"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropEventDarePlaceholder = void 0;
const dropEvent_context_1 = require("root/src/client/web/record/DropEvent/contexts/dropEvent.context");
const providers_1 = __importDefault(require("root/src/shared/constants/providers"));
const dare_1 = require("root/src/client/web/list/listItemComponents/dare/contexts/dare");
const DareCard_1 = require("root/src/client/web/list/listItemComponents/dare/DareCard");
const DropEventDarePlaceholder = () => {
    const dareCardContext = useDropEventDareCardPlaceholder();
    return (<dare_1.DareContextProvider value={dareCardContext}>
			<DareCard_1.DareCard />
		</dare_1.DareContextProvider>);
};
exports.DropEventDarePlaceholder = DropEventDarePlaceholder;
const useDropEventDareCardPlaceholder = () => {
    var _a, _b;
    const { toggleEmailSubscription, dropEvent, subscribed } = (0, dropEvent_context_1.useDropEventContext)();
    return {
        subscribed,
        emailSubscription: subscribed,
        comingSoon: true,
        brandProduct: {
            brandProductName: 'Coming soon',
        },
        onClick: toggleEmailSubscription,
        brand: dropEvent.brand,
        dare: {
            amount: '?',
            games: [
                { image: ((_a = dropEvent === null || dropEvent === void 0 ? void 0 : dropEvent.gameObj) === null || _a === void 0 ? void 0 : _a.image) || ((_b = dropEvent === null || dropEvent === void 0 ? void 0 : dropEvent.campaignThumbnail) === null || _b === void 0 ? void 0 : _b.url) },
            ],
            product: {
                name: 'Coming soon',
                id: 'Coming soon',
                type: 'unknown',
            },
            paymentInfo: {
                brandProductId: 'Coming soon',
                productType: 'unknown',
            },
            capacity: {
                available: '?',
                used: 0,
            },
            title: 'Coming soon',
            description: 'Coming soon',
            platform: providers_1.default.any,
            type: 'creative',
            level: 'easy',
            prizeAvailable: false,
            userCreated: false,
        },
    };
};
